import type { RouteObject } from 'react-router-dom';

// Rutas de src/fsd/ bajo /gates. appRoutes.tsx las monta dentro de AppLayout y de AmaruGuard
// (Sec:Compuertas).
export const gatesRoutes: RouteObject[] = [
  {
    // Enlace corto: solo el movimiento. El segmento estático gana sobre `:gateId`.
    path: 'movements/:movementId',
    lazy: () =>
      import('@fsd/pages/gate-movements').then((m) => ({ Component: m.MovementRedirectPage })),
  },
  {
    path: ':gateId/movements/:movementId?',
    lazy: () =>
      import('@fsd/pages/gate-movements').then((m) => ({ Component: m.GateMovementsPage })),
  },
];
